import { Thumbmark } from '@thumbmarkjs/thumbmarkjs';

window.fingerprint = null;
window.fetchingFingerprint = false;

const fingerprintRequests = [];

export default function getFingerprint() {
  if (window.fingerprint) {
    return window.fingerprint;
  }

  return new Promise((resolve, reject) => {
    if (window.fetchingFingerprint) {
      fingerprintRequests.push((err, fingerprint) => {
        if (err) {
          return reject(err);
        }

        return resolve(fingerprint);
      });

      return;
    }

    window.fetchingFingerprint = true;

    const tm = new Thumbmark();

    tm.get({ logging: false })
      .then((res) => {
        if (!res.thumbmark) {
          throw new Error('No thumbmark in response', res);
        }

        const { thumbmark } = res;

        window.fingerprint = thumbmark;
        fingerprintRequests.forEach(r => r(null, thumbmark));
        fingerprintRequests.length = 0;
        resolve(thumbmark);
        window.snowplow(function setFingerprint() {
          this.cf.xFanSetUserFingerprint(thumbmark);
        });
      })
      .catch((err) => {
        fingerprintRequests.forEach(r => r(err));
        fingerprintRequests.length = 0;
        resolve(err);
      });
  });
}
